import { useQuery } from '@tanstack/react-query';

import { adminsApi } from '@/lib/api';

import { queryKeys } from './query-keys';

export function useAdminsQuery() {
  return useQuery({
    queryKey: queryKeys.admins.list,
    queryFn: () => adminsApi.getAll(),
  });
}
